import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { AngularMaterialModule } from '@app/shared/modules/angular-material.module';
import { ToggleButtonIconStyle, ToggleButtonType } from '@shared/components/toggle-button';

@Component({
  selector: 'app-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule, AngularMaterialModule],

})
export class ToggleButtonComponent {
  ToggleButtonType = ToggleButtonType;
  ToggleButtonIconStyle = ToggleButtonIconStyle;
  @Input() buttonType: ToggleButtonType = ToggleButtonType.TEXT;
  @Input() iconStyle = ToggleButtonIconStyle.ADD_REMOVE;
  @Input() toggledText: string;
  @Input() unToggledText: string;
  @Input() toggled: boolean = false;
  @Output() clicked = new EventEmitter();

  click = () => {
    this.toggled = !this.toggled;
    this.clicked.emit(this.toggled);
  }
}
